import { Box, Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  margin: '20px 0',
  '& span': { color: theme.palette.secondary.main },
}));

export const InputBox = styled(Box)(() => ({
  margin: '30px 0',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '36px',
}));

export const ButtonContainer = styled(Box)(() => ({
  margin: '20px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  gap: '40px',
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '20px',
}));

export const ButtonTitle = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: '600',
  padding: '10px',
}));

type UploadButtonProps = {
  component: string;
};

export const UploadButton = styled(Button)<UploadButtonProps>(
  ({ component }) => ({
    display: 'flex',
    gap: '10px',
    component,
  })
);

export const OutlineButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  width: '100%',
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  fontWeight: '600',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  margin: '80px 0',
}));

export const EditSubmitBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '60px 0',
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  minWidth: '500px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const EditButton = styled(Button)(({ theme }) => ({
  minWidth: '250px',
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
  [theme.breakpoints.down('lg')]: {
    minWidth: '180px',
    maxWidth: '200px',
  },
}));

export const AssociateButton = styled(Button)(({ theme }) => ({
  minWidth: '250px',
  [theme.breakpoints.down('lg')]: {
    minWidth: '180px',
    maxWidth: '200px',
  },
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
  '&:disabled': {
    opacity: '80%',
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: '16px',
  },
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.grey,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.common.grey,
  },
}));
